export default __webpack_public_path__ + "static/media/menu.b37c9a10.png";